import React, { forwardRef } from "react";
import styles from "./LogbookItem.module.scss";

export const LogbookItemContainer = forwardRef<
  HTMLDivElement,
  React.HTMLAttributes<HTMLDivElement>
>(({ children, className, ...rest }, ref) => (
  <div
    ref={ref}
    className={`${styles.logbookItemContainer} ${className ?? ""}`}
    {...rest}>
    {children}
  </div>
));
LogbookItemContainer.displayName = "LogbookItemContainer";
